// extracted by mini-css-extract-plugin
export default {"home_title":"Home_home_title__yfI2z"};